import React, { useState, useEffect } from 'react';
import { labelApi } from '../../services/consts';
import {
    Button,
    Form,
    FormGroup,
    Label,
    Input,
    Card,
    CardTitle,
    CardBody
} from 'reactstrap';
import { tokenHeader, getUserToken } from "../../services/user-service";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const apiEndPoint = labelApi;
const AddLabel = (props) => {
    // const [visible, setVisible] = useState(true);
    const [labelName, setLabelName] = useState('');
    const [labelIsValid, setLabelIsValid] = useState(false);

    var doCancel = () => {
        props.history.push('/labels');
    }

    var addLabel = (e) => {
        e.preventDefault();
        let methodType = 'post';
        var labels = {
            name: labelName
        };
        if (labels.name == '') {
            toast.error('Label is required');
            return setLabelIsValid(true);
        }
        fetch(apiEndPoint, {
            method: methodType,
            body: JSON.stringify(labels),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                [tokenHeader]: getUserToken()
            }
        }).then(function (result) {
            if(result.status !== 500){
                toast.success('Label added');
                setTimeout(() => {
                    props.history.push('/labels');
                }, 1000);
            }
            else{
                toast.error('Label already exists');
            }
        })
    };
    var onHandleChange = (e) => {
        // console.log("e.target.name:"+e.target.name);
        if (e.target.name == 'labelName') {
            setLabelName(e.target.value);
        }
    }

    return (
        <div>
            <ToastContainer
                position="top-right"
                autoClose={2000}
                hideProgressBar={true}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <Card>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <i className="mdi mdi-tag-plus mr-2"> </i>
            Add Label
          </CardTitle>
                <CardBody className="">
                    <Form>
                        <FormGroup>
                            <Label>Label Name</Label>
                            <Input type="text" onChange={onHandleChange} name="labelName" id="labelName" placeholder="Label Name" />
                        </FormGroup>
                        <Button onClick={addLabel} color="success">Add</Button>&nbsp;&nbsp;&nbsp;
                        <Button type="btn btn-secondary" onClick={doCancel}>Cancel</Button>
                    </Form>
                </CardBody>
            </Card>
        </div>
    );
}

export default AddLabel;